import './App.css';
import React, { useEffect, useRef, useState } from "react";

import teamMembers from "./teamMembers";
import lightBulb from "./images/light-bulb.png"
import person from "./images/person.png"
import questionMark from "./images/question-mark.png"

import linkedIn from "./images/linkedin.png"
import mail from "./images/mail.png"
import CountdownDisplay from './SevenSegmentDisplay';

function App() {
    const [isInView, setIsInView] = useState(false);
    const sectionRef = useRef(null);
    
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsInView(true);
                }
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.5
            }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    const [isSection5InView, setIsSection5InView] = useState(false);
    const section5Ref = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsSection5InView(true);
                }
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.1
            }
        );

        if (section5Ref.current) {
            observer.observe(section5Ref.current);
        }

        return () => {
            if (section5Ref.current) {
                observer.unobserve(section5Ref.current);
            }
        };
    }, []);

    const [isSection6InView, setIsSection6InView] = useState(false);
    const section6Ref = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsSection6InView(true);
                }
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.7
            }
        );

        if (section6Ref.current) {
            observer.observe(section6Ref.current);
        }

        return () => {
            if (section6Ref.current) {
                observer.unobserve(section6Ref.current);
            }
        };
    }, []);

    const [showExplosion, setShowExplosion] = useState(false);

    const handleCountdownComplete = () => {
        setShowExplosion(true);
        setTimeout(() => {
            window.location.reload();  
        }, 1750);  
    }


    return (
        <div className="App">
            <div className="section section-1">
                <CountdownDisplay onComplete={handleCountdownComplete} />
                {showExplosion &&
                    <div className="explosion-overlay">
                        <iframe
                            src="https://giphy.com/embed/DGGIn1iJH0Nhe"
                            width="100%"
                            height="100%"
                            frameBorder="0"
                            className="giphy-embed"
                            allowFullScreen
                        ></iframe>
                    </div>
                }
            </div>
            <div className="section section-2" ref={sectionRef}>
                <div className={`frame ${isInView ? 'scale-up' : ''}`}>
                    <div className="frame-text">
                        An engaging <span className={"green"}>game</span>, themed around a tangible bomb, to bond with <span className={"green"}>friends</span> or even strangers. Beyond just fun, our mission was to boost communication skills and foster problem-solving alongside an <span className={"green"}>AI companion</span>. Dive in and discover if you’re able to <span className={"green"}>defuse the bomb</span>, or watch as the world ignites before your eyes...
                    </div>
                </div>
            </div>
            <div className="section section-4" ref={section5Ref}>
                <div className={`image-container image-left ${isSection5InView ? 'zoom' : ''}`}>
                    <div className="image-front"></div>
                    <div className="image-back">
                        <p>The individual at the computer must collaborate with the AI, seeking its expertise in bomb defusal. The bomb presents details on various disarming techniques and challenges the user to identify its type. Throughout the gameplay, the AI operator continuously seeks advice on tackling diverse tasks, leading up to the ultimate objective: successfully defusing the bomb.</p>
                    </div>
                </div>

                <div className="vertical-line"></div>

                <div className={`image-container image-right ${isSection5InView ? 'zoom' : ''}`}>
                    <div className="image-front"></div>
                    <div className="image-back">
                        <p>The individual handling the bomb carries the crucial responsibility of identifying and observing its distinctive features to aid in defusal. They are entrusted with executing the necessary actions to disarm the device, such as pressing buttons in a precise sequence or connecting specific wires.</p>
                    </div>
                </div>
            </div>
            <div className="section section-5">
                <div className={`group ${isSection6InView ? 'zoom' : ''}`}>
                    <div className={"green"}>what</div>
                    <img src={lightBulb} alt="Description 1" />
                    <div className={"description-text"}>In this game, players are placed in separate roles: one interacts with an AI to gather crucial information, while the other works on defusing a bomb. They can't see each other's task and must rely solely on communication. </div>
                </div>
                <div className={`group ${isSection6InView ? 'zoom' : ''}`}>
                    <div className={"green"}>who</div>
                    <img src={person} alt="Description 2" />
                    <div className={"description-text"}>Anyone open to a challenge and eager to test their communication skills under pressure. Designed for team-building events, educational settings, and escape room enthusiasts, it's a thrilling experience for friends and strangers.</div>
                </div>
                <div className={`group ${isSection6InView ? 'zoom' : ''}`}>
                    <div className={"green"}>why</div>
                    <img src={questionMark} alt="Description 3" />
                    <div className={"description-text"}>To get a unique blend of teamwork, communication, and technology while exploring the importance of human connection in a digital age and experiencing the satisfaction of collaborative problem-solving.</div>
                </div>
            </div>
            <div className="section section-6">
                {teamMembers.map(member => (
                    <div className="group-6" key={member.name}>
                        <img src={member.image} alt={member.name} className="circle-image" />
                        <div>{member.name}</div>
                        <div className="small-images">
                            <a href={member.linkedIn} target="_blank" rel="noopener noreferrer">
                                <img src={linkedIn} alt="LinkedIn" className="small-image" />
                            </a>
                            <a href={`mailto:${member.mail}`} target="_blank" rel="noopener noreferrer">
                                <img src={mail} alt="Resume" className="small-image" />
                            </a>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default App;
